<template>
  <div ref='testv__audio__player__container' class="testv__audio__player__container" :id="id">
    <div class="testv__audio__player__time">
      <span class="testv__audio__player__ptime">00:00:00</span>
      <span class="testv__audio__player__dtime">00:00:00</span>
    </div>

    <div class="testv__audio__player__controller">
      <div class="testv__audio__player__bar__wrapper custom__cursor__pointer">
        <div class="testv__audio__player__bar">
          <div class="testv__audio__player__loaded"></div>
          <div class="testv__audio__player__played" style="width: 0;">
            <span class="testv__audio__player__thumb">
              <span class="testv__audio__player__loading-icon"><i></i></span>
            </span>
          </div>
        </div>
        <div class="testv__audio__player__bar--copy">
          <div
            v-for="(item, index) in node" :key="index"
            :class="['testv__audio__player__node__wrapper', `${item.url ? 'large' : item.banner ? 'medium' : 'small'}`]"
            :data-time="item.time_slot">
            <span class="testv__audio__player__node"></span>
            <span class="testv__audio__player__node__title">{{ item.title }}</span>
          </div>
        </div>
      </div>

      <div class="testv__audio__player__buttons-wrap">
        <div class="testv__audio__player__speed__wrapper" data-speed="1" style="display: none;">
          <button class="testv__audio__player__speed-button">1X</button>
          <div class="testv__audio__player__speed-panel">
            <div v-for="value in [2, 1.5, 1.25, 1, 0.75, 0.5]" :key="value" class="testv__audio__player__speed-item" :data-speed="value">
              <span class="testv__audio__player__speed-label">{{ value }}X</span>
            </div>
          </div>
        </div>

        <div class="testv__audio__player__btns__wrapper">
          <SsButton2
            class="testv__audio__player__btn__play">
            <IconPlay id="TestvAudioPlayerIconPlay" class="testv__audio__player__icon"/>
            <IconPause id="TestvAudioPlayerIconPause" class="testv__audio__player__icon"/>
          </SsButton2>

          <div class="testv__audio__player__btn__group">
            <SsButton2
              class="testv__audio__player__btn__backward">
              <IconRewind class="testv__audio__player__icon"/>
              <span>15</span>
            </SsButton2>
            
            <SsButton2 class="testv__audio__player__btn__forward">
              <span>15</span>
              <IconForward class="testv__audio__player__icon"/>
            </SsButton2>
          </div>

          <div class="testv__audio__player__volume__wrapper custom__cursor__pointer" style="display: none;">
            <SsButton2
              type="text"
              class="testv__audio__player__volume-button">
              <IconLoudspeaker id="TestvAudioPlayerIconLoudspeaker" class="testv__audio__player__icon"/>
              <IconUnmute id="TestvAudioPlayerIconUnmute" class="testv__audio__player__icon"/>
            </SsButton2>
            <div class="testv__audio__player__volume__bar__wrapper">
              <div class="testv__audio__player__volume__bar">
                <div class="testv__audio__player__volume" style="width: 80%;"></div>
              </div>
            </div>
          </div>
        </div>

        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Player from './player.js'
import throttle from 'lodash/throttle'

export default {
  name: 'TestvAudioPlayer',

  components: {
  },

  props: {
    id: {
      type: String,
      default: ''
    }, 
    audio: {
      type: Object,
      required: true
    },
    node: {
      type: Array,
      default: () => ([])
    }
  },

  data () {
    return {
      player: null
    }
  },

  methods: {
    calcNodePosition (time) {
      if (this.player && !isNaN(time)) {
        time = Math.max(time, 0)
        time = Math.min(time, this.player.duration)
        // console.log(time / this.player.duration * 100)
        return time / this.player.duration * 100 + '%'
      }
      return 0
    }
  },

  mounted () {
    if (this.audio && this.audio.url) {
      const container = this.$refs['testv__audio__player__container']
      this.player = new Player({
        element: container,
        audio: this.audio,
        autoplay: true
      })
      this.player.notice = this.$toast
      this.player.on('play', () => {
        this.$emit('whenPlay', true)
      })
      this.player.on('pause', () => {
        this.$emit('whenPlay', false)
      })
      this.player.on('ended', () => {
        this.$emit('whenPlay', false)
      })
      this.player.on('timeupdate', throttle(e => {
        this.$emit('whenPlaying', e)
      }, 1000))
    }
  },

  destroyed () {
    this.player.audio.pause()
    this.player.audio.currentTime = 0
  }
}
</script>

<style lang="stylus">
@import '~@/assets/styles/variable.styl'
.testv__audio__player__container {
  --thickness: 56px;

  .testv__audio__player__btns__wrapper {
    display: flex;
    align-items: center;
    margin-top: 24px;
  }

  .testv__audio__player__btn__play {
    width: 80px;
    height: 64px;
    border-radius: 4px;
    background: var(--yellow-testv);
    color: var(--dark-bwb-0);
    .testv__audio__player__icon {
      width: 32px;
      height: 32px;
    }
    &:not(.playing) {
      #TestvAudioPlayerIconPause {
        display: none;
      }
    }
    &.playing {
      #TestvAudioPlayerIconPlay {
        display: none;
      }
    }
  }

  .testv__audio__player__btn__group {
    display: flex;
    column-gap: 2px;
    margin-left: auto;
    :first-child {
      border-top-left-radius: 64px;
      border-bottom-left-radius: 64px;
    }
    :last-child {
      border-top-right-radius: 64px;
      border-bottom-right-radius: 64px;
    }
  }

  .testv__audio__player__btn__backward,
  .testv__audio__player__btn__forward {
    width: 80px;
    height: 64px;
    background: var(--dark-bwb-2);
    color: var(--dark-bwb-8);
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 4px;
    font-size: 17px;
    font-family: "DottedSongtiSquare";
    .testv__audio__player__icon {
      width: 20px;
      height: 20px;
    }
  }

  .testv__audio__player__volume-button {
    width: 24px;
    height: 24px;
    color: var(--dark-bwb-8);
    .testv__audio__player__icon {
      width: 24px;
      height: 24px;
    }
    &:not(.off) {
      #TestvAudioPlayerIconUnmute {
        display: none;
      }
    }
    &.off {
      #TestvAudioPlayerIconLoudspeaker {
        display: none;
      }
    }
  }

  .testv__audio__player__bar__wrapper {
    position: relative;
    .testv__audio__player__bar {
      width: 100%;
      height: var(--thickness);
      background: var(--dark-bwb-2);
      position: relative;
      border-radius: 4px;
      overflow: hidden;

      .testv__audio__player__loaded {
        background: rgba(#fff, .2);
        height: var(--thickness);
        border-radius: 4px;
        position: absolute;
        left: 0;
        top: 0;
      }

      .testv__audio__player__played {
        background: rgba(#FFC000, 0.1);
        height: var(--thickness);
        position: absolute;
        left: 0;
        top: 0;

        .testv__audio__player__thumb {
          display: inline-block;
          width: 2px;
          height: var(--thickness);
          background: var(--yellow-testv);
          position: absolute;
          z-index: 10;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);

          .testv__audio__player__loading-icon {
            display none
            position absolute
            top 0
            left 0
            width 12px
            height 12px
            animation rotate 2s ease-in-out infinite
            animation-origin 50%
            & > i {
              display block
              width 100%
              height 100%
              background-image url(./assets/loading.svg)
              background-size 200%
              background-position center
              background-repeat no-repeat
            }
          }
        }
      }
    }

    .testv__audio__player__bar--copy {
      width: 100%;
      height: var(--thickness);
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 9;
    }
  }

  .testv__audio__player__node__wrapper {
    // visibility: hidden;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 6px;
    width: 4px;
    &.large {
      height: 4px;
    }
    &.medium {
      height: 4px;
    }
    &.small {
      height: 4px;
    }
    .testv__audio__player__node {
      display block
      width 100%
      height 100%
      background: var(--dark-bwb-6);
      border-radius: 50%;
    }
    .testv__audio__player__node__title {
      display: none;
      background: var(--yellow-testv);
      color: var(--dark-bwb-0);
      font-size: 16px;
      line-height: 30px;
      padding: 0 14px;
      position: absolute;
      left: 37px;
      white-space: nowrap;
      &::before {
        content ''
        display block
        width 40px
        height: 2px;
        background: var(--yellow-testv);
        transform: rotate(-45deg);
        transform-origin: right center;
        position: absolute;
        bottom: 0;
        left: -40px;
      }
    }
    &.large .testv__audio__player__node__title {
      top: -50px;
    }
    &.medium .testv__audio__player__node__title {
      top: -50px;
    }
    &.small .testv__audio__player__node__title {
      top: -50px;
    }
    &:hover {
      .testv__audio__player__node {
        background: var(--yellow-testv);
      }
      .testv__audio__player__node__title {
        display inline-block
      }
    }
  }

  .testv__audio__player__buttons-wrap {
    display block
    position relative
  }

  .testv__audio__player__volume__wrapper {
    display flex
    align-items center
    background: var(--dark-bwb-2);
    width: 142px;
    height: 80px;
    border-radius: 80px;
    padding: 20px;
    box-sizing: border-box;
    column-gap: 16px;
    .testv__audio__player__volume__bar__wrapper {
      width: 58px;
      padding: 4px;
      .testv__audio__player__volume__bar {
        background-image: url("~@/assets/images/line.png")
        background-size: auto 100%;
        height: 2px;
        .testv__audio__player__volume {
          background-image: url("~@/assets/images/line_yellow.png")
          background-size: auto 100%;
          height: 2px;
          position: relative;
          &::after {
            content: '';
            display: block;
            width: 2px;
            height: 10px;
            background: var(--yellow-testv);
            position: absolute;
            right: 0;
            top: -4px;
          }
        }
      }
    }
  }

  .testv__audio__player__speed__wrapper {
    position absolute
    top 50%
    left 186px
    transform translateY(-50%)
    .testv__audio__player__speed-button {
      cursor pointer
      width 36px
      height 36px
      border none
      background none
      font-size 12px
      color var(--B6-t)
      font-weight 900
    }
    .testv__audio__player__speed-panel {
      position absolute
      left 50%
      bottom 100%
      transform translate(-50%, -20px)
      border-radius 4px
      padding 6px 0
      visibility hidden
      opacity 0
      transition transform .2s
      border 2px solid var(--color-border-common)
      border-radius 16px

      .testv__audio__player__speed-item {
        cursor pointer
        font-size 12px
        font-weight 900
        text-align center
        line-height 40px
        width 96px
        transition .2s
        color var(--B6-t)
        &:hover {
          background var(--B10)
        }
      }
    }

    &:hover {
      .testv__audio__player__speed-panel {
        opacity 1
        visibility visible
        transform translate(-50%, 0)
      }
    }
  }

  .testv__audio__player__buttons-wrap {
    display flex
    flex-direction column
  }

  .testv__audio__player__time {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    font-size 13px;
    font-weight: 500;
    font-family: ui-monospace, 'SF Mono', monospace;
    line-height: 1;
    color: var(--dark-bwb-6);
  }
}

@keyframes rotate {
  0% {
    transform rotate(0deg)
  }
  100% {
    transform rotate(360deg)
  }
}

@media (min-width: $screen-md) {
  .testv__audio__player__container {
    --thickness: 64px;
    .testv__audio__player__btns__wrapper {
      margin-top: 32px;
    }
    .testv__audio__player__btn__play {
      width: 92px;
      height: 80px;
      .testv__audio__player__icon {
        width: 40px;
        height: 40px;
      }
    }
    .testv__audio__player__btn__group {
      margin-left: 32px;
    }
    .testv__audio__player__btn__backward,
    .testv__audio__player__btn__forward {
      width: 92px;
      height: 80px;
      font-size: 20px;
    }
    .testv__audio__player__volume__wrapper {
      margin-left: auto;
    }
  }
}
</style>
